<template>
  <div class="case-studies">
    <div class="qbcgBgDiv">
    <img src="../../../assets/yzcgBg.png" class="qbcgBg"/>
    </div>  

    <div class="yzcgDiv">
      <div v-if="newsList.length>0">
        <div class="caseStudiesDiv" v-for="(item) in newsList" :key="item.id"   @click="openDetail(item)">
          <div class="coverText"><span>{{item.title}}</span></div>
          <div class="caseHtml" v-html="stripImages(item.profile)"></div>
        </div>
      </div>

    <!-- <div class="coverVBox" v-if="newsList.length>0">
    <div class="coverDiv" v-for="(item,index) in newsList" :key="item.id"  :class="getBgClass(index)" @click="openDetail(item)">
    <img :src="item.imgs_src" class="coverImg"/>
    <div class="coverText"><span>{{item.title}}</span></div>
    </div>
    
    </div> -->
           <div style="display: flex;justify-content: center;margin-top: 40px;" v-else>
    <img src="../../../assets/empit.png" class="empitImg" />
    </div>
    </div> 
 
            <div class="pageBox" v-if="newsList.length>0">
        <el-pagination @size-change="sizePagination" :page-sizes="[2, 4, 10, 20]" @current-change="currentPagination" :page-size="form.pageSize"
          background layout="prev, pager, next,sizes" :total="projectTotal">
        </el-pagination>
      </div>
  </div>
</template>

<script>
export default {
  name: "CaseStudies",
  props: {
    
  },
  data(){
    return{
      testCotnent:'<p style=";text-indent: 37px;padding: 0;line-height: 24px"><span style="font-family: 仿宋;font-size: 19px"><span style="font-family:仿宋">为落实科技创新与产业创新融合部署，</span><span style="font-family:仿宋">2025年9月25日，中华国际科学交流基金会主办、昌平区政府支持举办科技产业对接会暨2025年新动能百优科技成果发布大会，双方搭建全链条成果转化载体，达成深度战略合作。</span></span></p><p style=";text-indent: 37px;padding: 0;line-height: 24px"><span style="font-family: 仿宋;font-size: 19px">双方共建</span><span style="font-family: 仿宋;font-size: 19px">北京市昌平区科技产业创新发展服务平台</span><span style="font-family: 仿宋;font-size: 19px"><span style="font-family:仿宋">并完成揭牌，联合全国多地政府签约共建，落地无人机、信创</span><span style="font-family:仿宋">5G、生物医药等10项高端产业项目；基金会牵头组建投资服务联合体，打通科技项目资本赋能通道。活动发布百项优质成果，启动2026年度成果征集，昌平区同步推介产业政策，组织项目路演与产学研资精准对接，形成常态化成果转化机制。</span></span></p><p style=";text-indent: 37px;padding: 0;line-height: 24px"><span style="font-family: 仿宋;font-size: 19px"><span style="font-family:仿宋">双方合作持续深化，</span><span style="font-family:仿宋">2026年2月共同落地</span></span><span style="font-family: 仿宋;font-size: 19px">杰工科技创新发展研究院</span><span style="font-family: 仿宋;font-size: 19px"><span style="font-family:仿宋">，</span><span style="font-family:仿宋">6月14日在昌平未来科学城正式揭牌运营，由基金会与昌平区科委联合主办开业活动，集聚多名院士以及30余名杰出工程师资源。研究院作为双方合作全新实体平台，承接工程师人才培育、核心技术攻关、成果产业化落地职能，活动现场签约了8家产业机构。</span></span></p><p style=";text-indent: 37px;padding: 0;line-height: 24px"><span style="font-family: 仿宋;font-size: 19px">如今双方形成完整创新闭环，整合基金会高端科研、工程师品牌资源与昌平政策、空间优势，联动全国多地开发区、投融资机构，构建跨区域协同创新生态，持续赋能区域新质生产力发展。</span></p><p><br/></p>',
      projectTotal:0,
      newsList:[],
      form: {
        currPage: 1,
        pageSize: 2,
        identify:4
      },
    }
  },
  mounted(){
    this.getTableList();
  },
  methods: {
    openDetail(item){
      this.$router.push({
        path: '/CoverDetail',
        query: {
        newsId: item.id,
        id:this.$route.query.id,
        active:3
        }
      });
    },
        sizePagination(e) {
      this.form.pageSize = e;
      this.getTableList();
    },
    currentPagination(e) {
      this.form.currPage = e;
      this.getTableList();
    },
    //     getBgClass(index) {
    //   const pos = index % 3;
    //   if (pos === 1) return 'bg2';
    // },
    getTableList(){
      this.$API.getNewsList(this.form).then(res => {
        this.newsList = res.data.list;
        this.projectTotal = res.data.pageInfo.allRows
        console.log(res);
      });
    },
    stripImages(html) {
      if (!html) return '';
      return html.replace(/<img[^>]*>/gi, '');
    }

  }
};
</script>

<style scoped>
.caseStudiesDiv{
  background-image: url('../../../assets/hdjjContentBg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 30px;
  max-height: 200px;
  overflow: hidden;
  padding: 22px 20px;
}
.caseHtml{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}
.coverText{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;
  color: #333;
  text-align: center;
}
.empitImg{
  width: 200px;
  height: 200px;
}
.pageBox {
  width: 100%;
  display: flex;
  justify-content: end;
  cursor: pointer;
  margin-bottom: 30px;
}
.bg2{
  margin: 0 20px;
}
.coverVBox{
  display: flex;
  flex-wrap: wrap;
}
.coverDiv{
  position: relative;
  margin-bottom: 20px;
}

.coverImg{
  width: 386px;
  height: 210px;
}
.yzcgDiv{
  border-radius: 4px;
  margin-bottom: 30px;
}
.qbcgBgDiv{
  display: flex;
  justify-content: center;
}
.qbcgBg{
  width: 462px;
  height: 72px;
  margin-top: 50px;
  margin-bottom: 30px;
}
</style>
